<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" :max-width="600" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-spacer
      .text-xl.font-bold.ml-10 New stock take
      v-spacer
      v-btn(icon @click="closeDialog" small color="primary")
        v-icon mdi-close
    v-divider
    v-card-text.px-6.py-3
      v-form(ref="form")
        div.text-md.font-semibold.neutral700--text Who’s inspecting this count?
        v-radio-group.text-md.mt-3(v-model="inspector" hide-details :rules="rules.not_empty" row)
          v-radio(value="self" color="neutral700" )
            template(#label)
              div.text-md.font-medium.neutral700--text Myself
          v-radio(value="others" color="basic700" )
            template(#label)
              div.text-md.font-medium.neutral700--text Other user
        template(v-if="inspector === 'others'")
          div.text-sm.font-semibold.neutral500--text.mt-4 Choose count inspector
          y-select.mt-2(v-model="selectedUser" placeholder="Select user" :items="users" item-text="name" item-value="id" :rules="rules.not_empty_select")

    v-card-actions.pb-4.pt-3.px-6
      y-button.mr-4(:label="$t('cancel')" underline color="neutral700" size="md" button-class="px-0" @click="closeDialog")
      v-spacer
      y-button(label="Start" text-color="neutral100" color="neutral700" size="md" dark :loading="isLoading" @click="saveData")

</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  components: {  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    warehouseSlug: {
      type: String,
      default: null
    },
  },
  data () {
    return {
      isFetching: false,
      isLoading: false,
      inspector: null,
      selectedUser: null,
      users: [],
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 0|| `Amount should be more than ${this.$currency.symbol} 0`],
        not_empty_select: [v => !!v || 'This field is required'],
      },
    }
  },
  computed: {
    ...mapState('user', ['member']),
    ...mapGetters({ company: 'getCompany', isHq: 'hq/getIsHq' }),
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  mounted () {
    this.fetchUsers()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchUsers () {
      let params = {
        page_size: -1,
        fields: 'id,name'
      }
      this.$axios.get(`/clinics/${this.company.slug}/members`, { params })
        .then(resp => {
          if (resp.data && resp.data.results) {
            this.users = resp.data.results
          }
        })
    },
    saveData () {
      if (!this.$refs.form.validate()) {
        this.showMessage(['error', this.$t('error_message.please_fill_out_all_required')])
        return
      }
      this.isLoading = true
      let memberid = this.member.id
      if (this.inspector === 'others') {
        memberid = this.selectedUser
      }
      this.$axios.post(`/clinics/${this.warehouseSlug || this.company.slug}/stock_takes`, { member_id: memberid })
        .then(resp => {
          if (this.isHq) {
            this.$emit('created', resp.data)
          } else {
            this.$router.push(`/admin/clinic/stocktake/${resp.data.id}`)
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
          this.closeDialog()
        })
    },
    closeDialog () {
      this.showDialog = false
      this.$emit('closed')
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
  .date-field .v-input__append-inner {
    margin-top: 12px !important;
  }
}
</style>